import fp from "lodash/fp";

import { PosSubscriptionServices } from "globalConstants";
import { convertDateToISO, TIME_OFFSET_DAY_END } from "helpers";
import { CadenceTypes } from "types/enums";

export const getTerminalSolutionBody = ({
	page,
	filters,
	sortBy,
	PAGE_SIZE,
}) => {
	const _filters = fp.cloneDeep(filters);
	return {
		page_index: page,
		page_size: PAGE_SIZE,
		sort_type: sortBy?.id || undefined,
		ascending: sortBy?.id ? sortBy?.desc : undefined,
		terminal_solution_types: _filters?.terminal_solution_types?.map(
			x => x.value,
		),
		complete_or_update_by: _filters?.ts_comp_upd_by?.id || undefined,
		terminal_type: _filters?.eb_ownership?.name || undefined,
		mid: _filters?.ts_mid,
		gateway_id: _filters?.ts_gateway_id,
		agent_office_name: _filters?.ts_agent_office_name,
		dba_name: _filters?.ts_dba_name,
		agent_office_id: _filters?.agent_office_id,
		agent_name: _filters?.ts_agent_name,
		agent_id: _filters?.agent_id?.id,
		number: _filters?.ts_number,
		statuses: _filters?.statuses?.map(x => x.value),
		file_build_options: _filters?.file_build_options?.map(x => x.value),
		origin: _filters?.ts_origin?.value,
		complete_or_update_from: convertDateToISO(
			_filters?.ts_completeUpdate?.[0],
		),
		complete_or_update_to: convertDateToISO(
			_filters?.ts_completeUpdate?.[1],
			{ addTime: TIME_OFFSET_DAY_END },
		),
		tid_v_number: _filters?.ts_tid_v_number,
		installed_from: convertDateToISO(_filters?.ts_installDate?.[0]),
		installed_to: convertDateToISO(_filters?.ts_installDate?.[1], {
			addTime: TIME_OFFSET_DAY_END,
		}),
		uninstalled_from: convertDateToISO(_filters?.ts_unInstallDate?.[0]),
		uninstalled_to: convertDateToISO(_filters?.ts_unInstallDate?.[1], {
			addTime: TIME_OFFSET_DAY_END,
		}),
		manufaturer_ids: _filters?.manufaturer_ids?.map(item => item.id),
		model_ids: _filters?.model_ids?.map(item => item.id),
		serial_number: _filters?.ts_serial_number,
		gateway_name_ids: _filters?.gateway_name_ids?.map(x => x.id),
		product_name: _filters?.ts_product_name,
	};
};

export const initialSubscriptionValues = {
	discount: "0.00",
	totalPrice: "0.00",
	posSystem: {
		billingCadence: CadenceTypes.Monthly,
		cost: PosSubscriptionServices.PosSystem.defaultPrice.monthly,
		quantity: "1",
		isSubscribed: true,
	},
	marketingServices: {
		billingCadence: CadenceTypes.Monthly,
		cost: PosSubscriptionServices.MarketingServices.defaultPrice.monthly,
		quantity: "1",
		isSubscribed: false,
	},
	ipPhoneService: {
		billingCadence: CadenceTypes.Monthly,
		cost: PosSubscriptionServices.IpPhoneService.defaultPrice.monthly.one,
		quantity: "1",
		isSubscribed: false,
	},
	tapToPay: {
		billingCadence: CadenceTypes.Monthly,
		cost: PosSubscriptionServices.TapToPay.defaultPrice.monthly,
		quantity: "1",
		isSubscribed: false,
	},
	salonInTheBox: {
		billingCadence: CadenceTypes.OneTime,
		cost: PosSubscriptionServices.SalonInTheBox.defaultPrice.oneTime,
		quantity: "1",
		isSubscribed: false,
	},
	smsService: {
		billingCadence: CadenceTypes.Monthly,
		cost: PosSubscriptionServices.SmsService.defaultPrice.monthly,
		quantity: "1",
		isSubscribed: false,
	},
	smsMessage: {
		billingCadence: CadenceTypes.Consumption,
		cost: PosSubscriptionServices.SmsMessage.defaultPrice.consumption,
		quantity: null,
		isSubscribed: false,
	},
	smsSetup: {
		billingCadence: CadenceTypes.OneTime,
		cost: PosSubscriptionServices.SmsSetup.defaultPrice.oneTime,
		quantity: "1",
		isSubscribed: false,
	},
};
